//core
import React, { useEffect } from 'react';
import { ObjType } from "../../../../utils";
import { useTranslation } from "react-i18next";
import {Box, Typography} from "@mui/material";
import { useSelector } from "react-redux";

//styles
import { useStyles } from "../../styles";
import { ChipYellow } from "../../../../styles";

//store
import { selectUploadConfigData } from "../../../../../../../store/common/configuration/selectors";

//hooks
import { useConfiguration } from "../../../../../../../store/common/configuration/useConfiguration";
import { getSymbolFromCode } from "currency-code-symbol-map";

interface ICpaStepsProps {
  data: ObjType[];
}

const CpaSteps: React.FC<ICpaStepsProps> = ({
  data,
}): JSX.Element => {
  const { t } = useTranslation();
  const styles = useStyles();

  const { getUploadConf } = useConfiguration();

  const uploadConfigData = useSelector(selectUploadConfigData);

  useEffect(() => {
    if (!uploadConfigData) {
      getUploadConf();
    }
  }, [uploadConfigData]);

  return (
    <>
      {!!data.length && data.map((item: any, i: number) => {
        const attributes = item.data.condition_step_items_attributes[0];
        const desired_value = attributes.desired_value !== null ? attributes.desired_value : '';

        return (
          !item.data.product && (
            <Box className={styles.field} key={`step-${i}`}>
              <Typography variant="body2">
                {`${t("admin.deals.summary.step_label")} ${i+1} - `}
              </Typography>

              <ChipYellow
                size="small"
                label={`${item.data.payment_size} ${(!!uploadConfigData.defaultCurrency && !attributes.obtained_result.includes('count') && attributes.obtained_result !== 'player_verified' && attributes.obtained_result !== 'player_contact_verified' ? getSymbolFromCode(uploadConfigData.defaultCurrency.toUpperCase() || '$') : '')}`}
              />

              <Typography variant="body2">
                {t("admin.deals.summary.step_when")}
              </Typography>

              <ChipYellow
                size="small"
                label={`${t(`common.components.obtained_result_cpa.${attributes.obtained_result}`)} ${t(`admin.deals.summary.comparison.${attributes.condition_for_comparison}`)} ${desired_value}`}
              />
            </Box>
          )
        )
      })}
    </>
  );
};

export default CpaSteps;
